import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useMatch } from "react-router-dom";
import { ProfileAdPopup } from "../components/profile-ad";
import { AppLayout } from "../components/layouts/app";
import Loading from "../components/Loading";

const HomePage = lazy(() => import("../pages/Home"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

const ProfilesListPage = lazy(() => import("../pages/profiles/ProfilesListPage"));
const ProfileDetailPage = lazy(() => import("../pages/profiles/ProfileDetailPage"));

const ProductsListPage = lazy(() => import("../pages/products/ProductsListPage"));
const ProductDetailPage = lazy(() => import("../pages/products/ProductDetailPage"));

const SearchPage = lazy(() => import("../pages/search/SearchPage"));
const FavoritesPage = lazy(() => import("../pages/favorites/FavoritesPage"));

const AboutPage = lazy(() => import("../pages/static/AboutPage"));
const ContactPage = lazy(() => import("../pages/static/ContactPage"));
const LegalNoticePage = lazy(() => import("../pages/static/LegalNoticePage"));
const PrivacyPolicyPage = lazy(() => import("../pages/static/PrivacyPolicyPage"));
const TermsPage = lazy(() => import("../pages/static/TermsPage"));

const withSuspense = (element: React.ReactNode) => (
  <Suspense fallback={<Loading />}>{element}</Suspense>
);

const ProfileAdOutsideDetails: React.FC = () => {
  const profileDetail = useMatch("/profils/:slug");
  const productDetail = useMatch("/produits/:slug");

  if (profileDetail || productDetail) return null;

  return <ProfileAdPopup />;
};

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={withSuspense(<HomePage />)} />

          <Route path="/profils" element={withSuspense(<ProfilesListPage />)} />
          <Route path="/profils/:slug" element={withSuspense(<ProfileDetailPage />)} />

          <Route path="/produits" element={withSuspense(<ProductsListPage />)} />
          <Route path="/produits/:slug" element={withSuspense(<ProductDetailPage />)} />

          <Route path="/recherche" element={withSuspense(<SearchPage />)} />
          <Route path="/favoris" element={withSuspense(<FavoritesPage />)} />

          <Route path="/a-propos" element={withSuspense(<AboutPage />)} />
          <Route path="/contact" element={withSuspense(<ContactPage />)} />
          <Route path="/mentions-legales" element={withSuspense(<LegalNoticePage />)} />
          <Route path="/confidentialite" element={withSuspense(<PrivacyPolicyPage />)} />
          <Route path="/conditions-utilisation" element={withSuspense(<TermsPage />)} />
        </Route>

        <Route path="*" element={withSuspense(<NotFoundPage />)} />
      </Routes>

      <ProfileAdOutsideDetails />
    </BrowserRouter>
  );
};

export default AppRouter;